import { Box, Container, Flex, Link, Text, Divider } from "@chakra-ui/react"
import { Link as RouterLink } from "react-router-dom"

export default function Footer() {
  return (
    <Box as="footer" bg="gray.50" py={4} mt={8}>
      <Container maxW="container.xl">
        <Divider mb={4} />
        <Flex
          direction={{ base: "column", md: "row" }}
          justify="space-between"
          align={{ base: "center", md: "center" }}
          fontSize="sm"
        >
          <Text>&copy; {new Date().getFullYear()} SpearBI. All rights reserved.</Text>
          <Flex mt={{ base: 2, md: 0 }} gap={4}>
            <Link as={RouterLink} to="/terms" color="gray.600" _hover={{ color: "blue.500" }}>
              Terms & Conditions
            </Link>
            <Link as={RouterLink} to="/privacy" color="gray.600" _hover={{ color: "blue.500" }}>
              Privacy Policy
            </Link>
          </Flex>
        </Flex>
      </Container>
    </Box>
  )
}
